// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-msg[data-v-6293fef9]{text-align:center;padding:2rem 0}.loading-msg .spinner[data-v-6293fef9]{width:40px;height:40px;margin-right:12px;color:#c9cdd4}.loading-msg .message[data-v-6293fef9]{font-size:1.5rem;font-weight:700}.loading-msg .progress[data-v-6293fef9]{margin-right:auto;margin-left:auto;width:480px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
